interface RestaurantOption {
  id: number;
  name: string;
}

interface ReportFiltersBarProps {
  restaurants: RestaurantOption[];
  selectedRestaurantId: number | null;
  onRestaurantChange: (id: number | null) => void;
  startDate: string;
  onStartDateChange: (d: string) => void;
  endDate: string;
  onEndDateChange: (d: string) => void;
}

/**
 * Restaurant + date-range picker bar shared by all /reports/* sub-pages.
 * Self-corrects out-of-order date entries.
 */
export function ReportFiltersBar({
  restaurants,
  selectedRestaurantId,
  onRestaurantChange,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
}: ReportFiltersBarProps) {
  return (
    <div className="card">
      <div className="card-body">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label htmlFor="restaurant-select" className="block text-sm font-medium text-gray-700 mb-1">
              Restaurant
            </label>
            <select
              id="restaurant-select"
              value={selectedRestaurantId || ''}
              onChange={(e) => onRestaurantChange(e.target.value ? Number(e.target.value) : null)}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
            >
              <option value="">Select Restaurant</option>
              {restaurants.map((restaurant) => (
                <option key={restaurant.id} value={restaurant.id}>
                  {restaurant.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="start-date" className="block text-sm font-medium text-gray-700 mb-1">
              Start Date
            </label>
            <input
              id="start-date"
              type="date"
              value={startDate}
              max={endDate}
              onChange={(e) => {
                const v = e.target.value;
                onStartDateChange(v);
                if (v && endDate && v > endDate) onEndDateChange(v);
              }}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
            />
          </div>
          <div>
            <label htmlFor="end-date" className="block text-sm font-medium text-gray-700 mb-1">
              End Date
            </label>
            <input
              id="end-date"
              type="date"
              value={endDate}
              min={startDate}
              onChange={(e) => {
                const v = e.target.value;
                onEndDateChange(v);
                if (v && startDate && v < startDate) onStartDateChange(v);
              }}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
